module.exports = __webpack_public_path__ + "static/media/kid12.493dfb2e.png";